export default __webpack_public_path__ + "static/media/channel-300w-min.e4e87951.jpeg";